import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "empty-state"
}

import { IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonMenuButton, IonPage, IonReorderGroup, IonSegment, IonSegmentButton, IonTitle, IonToolbar, onIonViewDidLeave, onIonViewDidEnter } from '@ionic/vue';
import { computed, ref } from 'vue';
import { addOutline, balloonOutline, saveOutline } from 'ionicons/icons';
import RuleItem from '@/components/RuleItem.vue'
import FacilityItem from '@/components/FacilityItem.vue'
import { translate } from '@hotwax/dxp-components';
import ScheduleRuleItem from '@/components/ScheduleRuleItem.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import emitter from '@/event-bus';
import { doReorder, showToast } from '@/utils';
import { RuleService } from '@/services/RuleService';
import ArchivedRuleItem from '@/components/ArchivedRuleItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StorePickup',
  setup(__props) {

const store = useStore();
const router = useRouter()

const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);
const rules = computed(() => store.getters["rule/getRules"]);
const isScrollable = computed(() => store.getters["util/isFacilitiesScrollable"]);
const facilities = computed(() => store.getters["util/getFacilities"]);
const selectedSegment = computed(() => store.getters["util/getSelectedSegment"]);
const isReorderActive = computed(() => store.getters["rule/isReorderActive"]);
const pickupGroups = computed(() => store.getters["util/getPickupGroups"]);
const archivedRules = computed(() => store.getters["rule/getArchivedRules"]);

const reorderingRules = ref([]);
const isScrollingEnabled = ref(false);
const contentRef = ref({}) as any;
const infiniteScrollRef = ref({}) as any;

onIonViewDidEnter(async() => {
  fetchRules();
  emitter.on("productStoreOrConfigChanged", fetchRules);
})

onIonViewDidLeave(() => {
  emitter.off("productStoreOrConfigChanged", fetchRules);
  store.dispatch("rule/updateIsReorderActive", false)
})

async function fetchRules() {
  emitter.emit("presentLoader");
  store.dispatch("rule/updateIsReorderActive", false)
  if(!selectedSegment.value || (selectedSegment.value !== 'RG_PICKUP_FACILITY' && selectedSegment.value !== 'RG_PICKUP_CHANNEL' && selectedSegment.value !== 'PICKUP_FACILITY')) await store.dispatch("util/updateSelectedSegment", "RG_PICKUP_FACILITY");
  if(selectedSegment.value === 'PICKUP_FACILITY') {
    await Promise.allSettled([fetchFacilities(), store.dispatch("util/fetchPickupGroups")]) ;
  } else {
    await Promise.allSettled([store.dispatch('rule/fetchRules', { groupTypeEnumId: selectedSegment.value, pageSize: 50 }), store.dispatch("util/fetchConfigFacilities"), store.dispatch("util/fetchFacilityGroups")])
  }
  emitter.emit("dismissLoader");
}

async function fetchFacilities(vSize?: any, vIndex?: any) {
  const pageSize = vSize ? vSize : process.env.VUE_APP_VIEW_SIZE;
  const pageIndex = vIndex ? vIndex : 0;
  const payload = {
    pageSize,
    pageIndex
  };
  await store.dispatch('util/fetchFacilities', payload)
}

function enableScrolling() {
  const parentElement = contentRef.value.$el
  const scrollEl = parentElement.shadowRoot.querySelector("div[part='scroll']")
  let scrollHeight = scrollEl.scrollHeight, infiniteHeight = infiniteScrollRef.value.$el.offsetHeight, scrollTop = scrollEl.scrollTop, threshold = 100, height = scrollEl.offsetHeight
  const distanceFromInfinite = scrollHeight - infiniteHeight - scrollTop - threshold - height
  if(distanceFromInfinite < 0) {
    isScrollingEnabled.value = false;
  } else {
    isScrollingEnabled.value = true;
  }
}

async function loadMoreFacilities(event: any) {
  // Added this check here as if added on infinite-scroll component the Loading content does not gets displayed
  if(!(isScrollingEnabled.value && isScrollable.value)) {
    await event.target.complete();
  }
  fetchFacilities(
    undefined,
    Math.ceil(
      facilities.value?.length / (process.env.VUE_APP_VIEW_SIZE as any)
    ).toString()
  ).then(async () => {
    await event.target.complete();
  });
}

async function updateSegment(event: any) {
  store.dispatch("util/updateSelectedSegment", event.detail.value);

  emitter.emit("presentLoader");
  if(selectedSegment.value === 'PICKUP_FACILITY') {
    isScrollingEnabled.value = false;
    await fetchFacilities();
    store.dispatch("rule/updateIsReorderActive", false)
    store.dispatch("util/fetchPickupGroups")
  } else {
    store.dispatch("rule/updateIsReorderActive", false)
    reorderingRules.value = []
    await store.dispatch('rule/fetchRules', { groupTypeEnumId: selectedSegment.value, pageSize: 50 })
  }
  emitter.emit("dismissLoader");
}

function activateReordering() {
  store.dispatch("rule/updateIsReorderActive", true)
  reorderingRules.value = rules.value;
}

async function saveReorder() {
  const diffRules = reorderingRules.value.filter((reorderRule: any) => rules.value.some((rule: any) => rule.ruleId === reorderRule.ruleId && rule.sequenceNum !== reorderRule.sequenceNum))
  if(!diffRules.length) {
    store.dispatch("rule/updateIsReorderActive", false)
    showToast(translate("No sequence has been changed."))
    return;
  }

  emitter.emit("presentLoader", { messgae: "Saving changes.." })
  const responses = await Promise.allSettled(diffRules.map(async (rule: any) => {
    await RuleService.updateRule(rule, rule.ruleId)
  }))

  const isFailedToUpdateSomeRule = responses.some((response) => response.status === 'rejected')
  if(isFailedToUpdateSomeRule) {
    showToast(translate("Failed to update sequence for some rules."))
  } else {
    showToast(translate("Sequence for rules updated successfully."))
  }
  emitter.emit("dismissLoader");
  await store.dispatch('rule/updateRules', { rules: reorderingRules.value })
  store.dispatch("rule/updateIsReorderActive", false)
}

function updateReorderingRules(event: any) {
  reorderingRules.value = doReorder(event, reorderingRules.value)
}

function createStorePickup() {
  router.push("create-store-pickup")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenuButton), { slot: "start" }),
              _createVNode(_unref(IonTitle), { slot: "start" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Store pickup")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegment), {
                value: selectedSegment.value,
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (updateSegment($event))),
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegmentButton), { value: "RG_PICKUP_FACILITY" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Product and facility")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "RG_PICKUP_CHANNEL" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Product and channel")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "PICKUP_FACILITY" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Facility")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        ref_key: "contentRef",
        ref: contentRef,
        "scroll-events": true,
        onIonScroll: _cache[3] || (_cache[3] = ($event: any) => (enableScrolling()))
      }, {
        default: _withCtx(() => [
          (selectedSegment.value !== 'PICKUP_FACILITY')
            ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (ruleGroup.value.ruleGroupId && (rules.value.length || archivedRules.value.length))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (rules.value.length)
                        ? (_openBlock(), _createBlock(ScheduleRuleItem, { key: 0 }))
                        : _createCommentVNode("", true),
                      (archivedRules.value?.length)
                        ? (_openBlock(), _createBlock(ArchivedRuleItem, { key: 1 }))
                        : _createCommentVNode("", true),
                      (rules.value.length)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                            _createVNode(_unref(IonReorderGroup), {
                              disabled: false,
                              onIonItemReorder: _cache[1] || (_cache[1] = ($event: any) => (updateReorderingRules($event)))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((isReorderActive.value ? reorderingRules.value : rules.value), (rule, ruleIndex) => {
                                  return (_openBlock(), _createBlock(RuleItem, {
                                    rule: rule,
                                    ruleIndex: ruleIndex,
                                    key: rule.ruleId
                                  }, null, 8, ["rule", "ruleIndex"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("p", null, _toDisplayString(_unref(translate)("No store pickup rule found.")), 1)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("main", _hoisted_4, [
                (!pickupGroups.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("p", null, _toDisplayString(_unref(translate)("No store pickup group found linked with current product store.")), 1)
                    ]))
                  : (facilities.value.length)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilities.value, (facility) => {
                          return (_openBlock(), _createBlock(FacilityItem, {
                            facility: facility,
                            key: facility.facilityId
                          }, null, 8, ["facility"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("p", null, _toDisplayString(_unref(translate)("No facility found.")), 1)
                      ]))
              ])),
          _withDirectives(_createVNode(_unref(IonInfiniteScroll), {
            onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (loadMoreFacilities($event))),
            threshold: "100px",
            ref_key: "infiniteScrollRef",
            ref: infiniteScrollRef
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonInfiniteScrollContent), {
                "loading-spinner": "crescent",
                "loading-text": _unref(translate)('Loading')
              }, null, 8, ["loading-text"])
            ]),
            _: 1
          }, 512), [
            [_vShow, selectedSegment.value === 'PICKUP_FACILITY' && isScrollable.value]
          ])
        ]),
        _: 1
      }, 512),
      (selectedSegment.value !== 'PICKUP_FACILITY')
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed",
            class: "ion-margin"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                disabled: !rules.value.length,
                class: "ion-margin-bottom",
                color: "light",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (isReorderActive.value ? saveReorder() : activateReordering()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: isReorderActive.value ? _unref(saveOutline) : _unref(balloonOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(IonFabButton), {
                disabled: isReorderActive.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (createStorePickup()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})